import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TableActionsMenu from "../../../../Components/TableActionsMenu/TableActionsMenu";
import styles from "./FieldsTable.styles";
import { toTitleCase } from "../../../../utility/Utils";
import { useTranslation } from "../../../../context/Internationalization";

const FieldsTableRow = ({ field, menuActions, lastElementRef }) => {
  const { t } = useTranslation();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openPhotoModal, setOpenPhotoModal] = useState(false);

  const menuActionsOpen = Boolean(menuAnchorEl);

  const handleClickActionMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseActionMenu = () => {
    setMenuAnchorEl(null);
  };

  const handlePhotoClick = () => {
    setOpenPhotoModal(true);
  };

  const handleClosePhotoModal = () => {
    setOpenPhotoModal(false);
  };

  return (
    <>
      <TableRow
        ref={lastElementRef}
        key={field._id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        {/* Field Logo */}
        <TableCell component="th" scope="row">
          {field?.photo ? (
            <img
              src={field.photo}
              alt={field.name || "Field Logo"}
              loading="lazy"
              onClick={handlePhotoClick}
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.style.cursor = "default";
              }}
              style={styles.fieldPhoto}
            />
          ) : (
            <div style={styles.noImage}>
              <span style={styles.noImageText}>{t("no_image")}</span>
            </div>
          )}
        </TableCell>

        {/* Field Name */}
        <TableCell>
          <Typography variant="subtitle1">
            {toTitleCase(field?.name)}
          </Typography>
        </TableCell>

        {/* Field Location */}
        <TableCell>
          <Typography variant="subtitle1">{field.location?.address}</Typography>
        </TableCell>

        {/* Actions */}
        <TableCell>
          <TableActionsMenu
            handleClickAction={handleClickActionMenu}
            handleCloseActionMenu={handleCloseActionMenu}
            rowData={field}
            actions={menuActions}
            anchorEl={menuAnchorEl}
            open={menuActionsOpen}
          />
        </TableCell>
      </TableRow>

      {/* Photo Modal */}
      <Dialog
        open={openPhotoModal}
        onClose={handleClosePhotoModal}
        maxWidth="md"
      >
        <DialogContent sx={styles.dialogContent}>
          <IconButton onClick={handleClosePhotoModal} sx={styles.closeIcon}>
            <CloseIcon />
          </IconButton>
          <img src={field?.photo} alt={field.name} style={styles.imgDialog} />
        </DialogContent>
      </Dialog>
    </>
  );
};

FieldsTableRow.propTypes = {};

export default FieldsTableRow;
